/**
 * Creates a deep copy of the input object.
 *
 * @param object - The object to be cloned.
 * @returns The cloned object.
 */
export default (object: any) => {
  return JSON.parse(JSON.stringify(object))
}
